export { default } from "./CharacterCard";
